// @flow

import React, { Component }     from 'react';
import { connect }              from 'react-redux';
import { getTranslate }         from 'react-localize-redux';
import { handleLogout }         from 'actions/session/userAuth';
import documentHelper           from 'helpers/document.helper';
import './logout.css';

class Logout extends Component {

  componentDidMount() {
    const { location: { state: { email, id } }, dispatch, history } = this.props;

    // Call Customer Guru Survey (later it is included via iframe)
    if( email ) {
      let tempEmail = 'sfid.' + id + '@fp-dk.dk';
      window.cg.load(window.CUSTOMERGURU, tempEmail, { starfish_user: tempEmail });
    }

    // Logout
    dispatch(handleLogout(history));
  }

  componentWillMount() {
    const { translate } = this.props;
    // Document page title
    documentHelper.setTitle(translate('session.logout.title_document'));
  }

  render() {
    const { translate } = this.props;

    return (
      <div className="logout">
        <div className="logout-success">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
                <div className="top-header">
                  <h2>{translate('session.logout.title')}</h2>
                  <h4>{translate('session.logout.title_slogan')}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale)
});

export default connect(mapStateToProps)(Logout);



// WEBPACK FOOTER //
// ./src/components/session/logout/logout.js